import { render, staticRenderFns } from "./TableExtended.vue?vue&type=template&id=0b72a352&"
import script from "./TableExtended.vue?vue&type=script&lang=js&"
export * from "./TableExtended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports